import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../slices/authSlice';
import storeReducer from '../slices/storeSlice';
import employeeReducer from '../slices/employeeSlice';
import productReducer from '../slices/productSlice';
import saleReducer from '../slices/saleSlice';
import reportReducer from '../slices/reportSlice';
import warehouseReducer from '../slices/warehouseSlice';
import transferReducer from '../slices/transferSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    store: storeReducer,
    employee: employeeReducer,
    product: productReducer,
    sale: saleReducer,
    report: reportReducer,
    warehouse: warehouseReducer,
    transfer: transferReducer
  },
});

export default store;
